export class GroupedCategorySelectDialog {
  groups: {label: string; value: string}[];
  categories: {label: string; value: string; group: string; disabled: boolean; selected: boolean}[];
  single: boolean;
  isEdit: boolean;
}